import { render, staticRenderFns } from "./BankPaymentBody.vue?vue&type=template&id=27a46ee2&scoped=true&"
import script from "./BankPaymentBody.vue?vue&type=script&lang=ts&"
export * from "./BankPaymentBody.vue?vue&type=script&lang=ts&"
import style0 from "./BankPaymentBody.vue?vue&type=style&index=0&id=27a46ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a46ee2",
  null
  
)

export default component.exports